import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Images } from "lucide-react";
import api from "@/lib/apiClient";
import SEO from "@/components/SEO";
import CoverageList from "@/components/CoverageList";

export default function Media() {
  const [coverage, setCoverage] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/coverage").then(({ data }) => setCoverage(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="fade-in">
      <SEO title="Media & Public Communications — NPST" description="News coverage links and newspaper media clips of the National Public Service Trust." canonical={`${window.location.origin}/media`} />
      <section className="border-b border-npst-line paper-texture">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="label-eyebrow text-npst-gold mb-3">Newsroom</div>
          <h1 className="font-serif text-4xl sm:text-6xl font-semibold text-npst-ink tracking-tight">Media & Public Communications</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-4">
        <Link to="/media/clips" className="group flex items-center justify-between gap-6 border border-npst-line rounded-md bg-white p-6 sm:p-8 hover:border-npst-gold transition-colors shadow-sm" data-testid="open-clips-gallery-link">
          <div className="flex items-center gap-5">
            <div className="w-12 h-12 rounded-full bg-npst-goldLight flex items-center justify-center shrink-0">
              <Images size={22} className="text-npst-gold" />
            </div>
            <div>
              <div className="label-eyebrow text-npst-gold mb-1">Media Clips</div>
              <div className="font-serif text-2xl sm:text-3xl font-semibold text-npst-ink group-hover:text-npst-navy transition-colors">Newspaper & Media Gallery</div>
              <p className="text-sm text-npst-inkSoft mt-1">Search the archive of newspaper cuttings and media clips featuring the Trust.</p>
            </div>
          </div>
          <ArrowRight size={22} className="text-npst-gold shrink-0 group-hover:translate-x-1 transition-transform" />
        </Link>
      </section>

      <section id="in-the-news" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="label-eyebrow text-npst-gold mb-2">In the News</div>
        <h2 className="font-serif text-3xl sm:text-4xl font-semibold text-npst-ink mb-8">Media Coverage of the Trust</h2>
        {loading ? <div className="py-16 text-center text-npst-muted animate-pulse">Loading…</div>
          : coverage.length === 0 ? (
            <div className="py-16 text-center" data-testid="coverage-empty">
              <p className="font-serif text-2xl text-npst-ink">No coverage links yet</p>
              <p className="text-npst-muted mt-2">News articles and media coverage links will appear here.</p>
            </div>
          ) : <CoverageList items={coverage} />}
      </section>
    </div>
  );
}
